/* tslint:disable */
/* eslint-disable */
/**
 * View API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { ComparisonRuleValueFromJSON, ComparisonRuleValueToJSON } from './ComparisonRuleValue';

/**
 * 
 * @export
 * @interface ComparisonRule
 */

/**
* @export
* @enum {string}
*/
export var ComparisonRuleOperatorEnum = /*#__PURE__*/function (ComparisonRuleOperatorEnum) {
  ComparisonRuleOperatorEnum["Eq"] = "eq";
  ComparisonRuleOperatorEnum["Gte"] = "gte";
  ComparisonRuleOperatorEnum["Lte"] = "lte";
  ComparisonRuleOperatorEnum["Gt"] = "gt";
  ComparisonRuleOperatorEnum["Lt"] = "lt";
  ComparisonRuleOperatorEnum["Ne"] = "ne";
  ComparisonRuleOperatorEnum["Includes"] = "includes";
  return ComparisonRuleOperatorEnum;
}({});

/**
 * Check if a given object implements the ComparisonRule interface.
 */
export function instanceOfComparisonRule(value) {
  if (!('property' in value) || value['property'] === undefined) return false;
  if (!('operator' in value) || value['operator'] === undefined) return false;
  if (!('value' in value) || value['value'] === undefined) return false;
  return true;
}
export function ComparisonRuleFromJSON(json) {
  return ComparisonRuleFromJSONTyped(json, false);
}
export function ComparisonRuleFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    'property': json['property'],
    'operator': json['operator'],
    'value': ComparisonRuleValueFromJSON(json['value'])
  };
}
export function ComparisonRuleToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    'property': value['property'],
    'operator': value['operator'],
    'value': ComparisonRuleValueToJSON(value['value'])
  };
}